import { render } from "./popup.vue?vue&type=template&id=65ccffce&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=65ccffce&lang=css"
import "./popup.vue?vue&type=style&index=1&id=65ccffce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ccffce"]])

export default __exports__